<template>
<div class="footerBox">
  <van-tabbar :class="isipx=='1'?'isipx_bot':''"  v-model="active" @change="changeLike(active)">
    <van-tabbar-item>
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? icon.active1 : icon.inactive1" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>数据总览</span>
      <template #icon="props">
        <img :src="props.active ? icon.active2 : icon.inactive2" />
      </template>
    </van-tabbar-item>
<!--    <van-tabbar-item>-->
<!--      <span>检索查询</span>-->
<!--      <template #icon="props">-->
<!--        <img :src="props.active ? icon.active2 : icon.inactive2" />-->
<!--      </template>-->
<!--    </van-tabbar-item>-->
    <van-tabbar-item>
    <span>三年首过</span>
    <template #icon="props">
      <img :src="props.active ? icon.active3 : icon.inactive3" />
    </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>新闻政策</span>
      <template #icon="props">
        <img :src="props.active ? icon.active4 : icon.inactive4" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>个人中心</span>
      <template #icon="props">
        <img :src="props.active ? icon.active5 : icon.inactive5" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</div>
</template>

<script>
  import {islgdAddress} from '@/common/config.js'
  import img1 from './images/f1.png'
  import img11 from './images/f1-active.png'

  import img2 from './images/f2.png'
  import img22 from './images/f2-active.png'

  import img3 from './images/f3.png'
  import img33 from './images/f3-active.png'

  import img4 from './images/f4.png'
  import img44 from './images/f4-active.png'

  import img5 from './images/f5.png'
  import img55 from './images/f5-active.png'
    export default {
      name: "index",
      data() {
        return {
          active: -1,
          icon: {
            active1: img11,
            inactive1: img1,
            active2: img22,
            inactive2: img2,
            active3: img33,
            inactive3: img3,
            active4: img44,
            inactive4: img4,
            active5: img55,
            inactive5: img5,
          },
          isipx:3,
        };
      },
      mounted() {
        this.isipx=sessionStorage.getItem("isipx");
      },
      watch: {
        $route: 'changeActive'
      },
      created() {
        const toName = this.$route.name;
        this.setActive(toName);
      },
      methods: {
        changeActive({name}) {
          this.setActive(name);
        },
        setActive(name) {
          if (name == 'home') {
            this.active = 0
          }
          if (name == 'homes') {
            this.active = 1
          }
          // if (name == 'searchQuery') {
          //   this.active = 1
          // }
          if (name == 'firstPass') {
            this.active = 2
          }
          if (name == 'policy') {
            this.active = 3
          }
        },

        changeLike(n) {
          this.active = n
          if (n == 0) {
            this.$router.push({
              name: 'home',
              params: {}
            })
          }
          if (n == 1) {
            this.$router.push({
              name: 'homes',
              params: {}
            })
          }
          // if (n == 1) {
          //   this.$router.push({
          //     name: 'searchQuery',
          //     params: {}
          //   })
          // }
          if (n == 2) {
            this.$router.push({
              name: 'firstPass',
              params: {}
            })
          }
          if (n == 3) {
            this.$router.push({
              name: 'policy',
              params: {}
            })
          }
          if (n == 4) {
            setTimeout(() => {
              if (localStorage.getItem('pmcucookieH5')) {
                location.href =islgdAddress.personalCenterUrl+ '/index?library=islgd'
              } else {
                location.href =islgdAddress.personalCenterUrl+ '/login?type=3&library=islgd'
              }
            }, 200)
          }
        }

      }
    }
</script>

<style scoped>
  .isipx_bot{
    height:1.3rem!important;
  }
  .van-tabbar {
    z-index:98;
    height:.96rem
  }
  .van-tabbar-item{
    font-size: .2rem;
    font-weight: 400;
    color: #999999;
    line-height: .28rem;
  }
  .van-tabbar-item--active{
    color: #3991F1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue